import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { listMaintenancesService } from "../services/listMaintenances.service.js";
import debounce from "lodash.debounce";

export const useMaintenanceQuery = (filters) => {
  const fetchData = useFetch();
  const [maintenances, setMaintenances] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
        setLoading(true);
        const response = await listMaintenancesService(fetchData)({
          filters: { limit: 10, page: currentPage, ...filters },
        });
        setMaintenances(response.data);
        setTotalPages(response.totalPages);
        setTotal(response.total);
      } catch (error) {
        console.error("Error fetching maintenances:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchMaintenance, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, currentPage, filters]);

  return {
    maintenances,
    loading,
    refresh: () => setRefresh((prev) => !prev),
    total,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    totalPages,
  };
};
